import { CHART_BACKGROUND_COLOR, CHART_PALETTE, CHART_DEFAULT_SERIE_COLOR, TRANSPARENT } from '../../../utils/colors';
import { STROKE_STYLE } from '../charts.constants';
import { AUTO } from '../slopeChart/slopeChart.constants';

export const SLOPE_DEFAULT = {
  titlesVisibility: true,
  strokeWidth: 1,
  hoverStrokeWidth: 2,
  hoverAreaStrokeWidth: 5,
  labelSpace: 0.41,
  verticalMargin: 30,
  // DOTS & VALUES
  showValues: true,
  dotRadius: 12,
  fontSize: '0.7em',
  lineSize: 6,
  dotFill: CHART_BACKGROUND_COLOR,
  // GRID
  gridVisible: true,
  gridBackground: CHART_BACKGROUND_COLOR,
  gridRowLineStyle: STROKE_STYLE,
  gridColumnLineStyle: STROKE_STYLE,
  // AXES
  xAxisVisible: true,
  xAxisSpace: 20,
  xAxisTicksVisible: true,
  yAxisRightSide: true,
  yAxisVisible: true,
  yAxisOffset: 15,
  yAxisSpace: 40,
  xAxisBackgroundVisible: false,
  xAxisBackground: TRANSPARENT,
  labelAxisMargin: 15,
  // COLORS
  defaultColor: CHART_DEFAULT_SERIE_COLOR,
  colors: CHART_PALETTE,
};

export const ONLY_DOTS = {
  gridVisible: false,
  gridBackground: TRANSPARENT,
  showValues: false,
  dotRadius: 2,
  dotFill: AUTO,
  xAxisTicksVisible: false,
  yAxisOffset: 7,
  yAxisVisible: false,
};

export const getSlopeConfig = () => {
  return {
    chartHeight: 750,
    gridVisible: false,
    gridBackground: TRANSPARENT,
    gridBackgroundNarrow: true,
    yAxisVisible: false,
    xAxisTicksVisible: false,
    xAxisBackgroundVisible: true,
    xAxisBackground: CHART_BACKGROUND_COLOR,
  };
};
